// Área "auth" — preenchida na cobertura de 4 idiomas. Ver src/i18n/index.jsx.
// Fallback: idioma ausente cai para pt e, se faltar, para a própria chave.
const auth = {
  pt: {
    // LoginForm
    'auth.login_form_title': 'Bem-vindo ao DogBank',
    'auth.cpf_subtitle': 'Digite seu CPF para continuar',
    'auth.cpf_invalid': 'CPF inválido. Digite os 11 dígitos do seu CPF.',
    'auth.cpf_label': 'CPF',
    'auth.cpf_placeholder': '000.000.000-00',
    'auth.continue': 'Continuar',
    'auth.not_client_yet': 'Ainda não é cliente?',
    'auth.open_account': 'Abra sua conta',
    // PasswordForm
    'auth.password_title': 'Digite sua senha',
    'auth.password_subtitle': 'Para acessar sua conta DogBank',
    'auth.password_label': 'Senha',
    'auth.wrong_password_retry': 'Senha incorreta. Tente novamente.',
    'auth.back': 'Voltar',
    'auth.login': 'Entrar',
    'auth.signing_in': 'Entrando...',
    'auth.forgot_password': 'Esqueci minha senha',
    // LoginPage
    'auth.welcome_back': 'Bem-vindo de volta',
    'auth.login_hero_subtitle': 'Acesse sua conta e gerencie suas finanças de forma simples e segura.',
    'auth.advanced_security': 'Segurança Avançada',
    'auth.two_step_auth': 'Autenticação em 2 etapas',
    'auth.instant_pix': 'PIX Instantâneo',
    'auth.transfers_in_seconds': 'Transferências em segundos',
    'auth.back_to_home': 'Voltar ao início',
    'auth.login_account_title': 'Entre na sua conta',
    'auth.verifying': 'Verificando...',
    'auth.no_account': 'Não tem uma conta?',
    'auth.create_account': 'Criar conta',
    'auth.demo_disclaimer': 'Este é um projeto de demonstração. Não é um banco real.',
    // PasswordPage
    'auth.cpf_not_registered': 'CPF não cadastrado. Verifique o número digitado ou crie uma conta.',
    'auth.wrong_password_check': 'Senha incorreta. Verifique e tente novamente.',
    'auth.connection_error': 'Erro de conexão. Verifique sua internet e tente novamente.',
    'auth.generic_error': 'Ocorreu um erro. Tente novamente.',
    'auth.pin_length': 'Digite os {n} dígitos da senha.',
    'auth.user_not_found': 'Usuário não encontrado',
    'auth.login_error': 'Erro no login',
    'auth.back_verify_cpf': '← Voltar e verificar o CPF',
    'auth.secure_access': 'Acesso Seguro',
    'auth.password_hero_subtitle': 'Digite sua senha de 6 dígitos para acessar sua conta com total segurança.',
    'auth.advanced_encryption': 'Criptografia Avançada',
    'auth.advanced_encryption_desc': 'Seus dados protegidos com tecnologia de ponta',
    'auth.cpf_display': 'CPF: {n}',
    'auth.validating': 'Validando...',
    'auth.forgot_password_question': 'Esqueceu a senha?',
    'auth.recover_access': 'Recuperar acesso',
    // LandingPage
    'auth.nav_features': 'Recursos',
    'auth.nav_security': 'Segurança',
    'auth.nav_about': 'Sobre',
    'auth.access_account': 'Acessar conta',
    'auth.hero_badge': 'PIX, CDI 100% e Bitcoin em uma demo observável',
    'auth.hero_subtitle': 'Uma experiência bancária para demonstrar jornadas reais de PIX, carteira de investimentos e observabilidade ponta a ponta.',
    'auth.start_now': 'Começar agora',
    'auth.learn_more': 'Saiba mais',
    'auth.stat_transactional': 'Fluxo transacional',
    'auth.stat_fixed_income': 'Renda fixa',
    'auth.stat_market_price': 'Cotação de mercado',
    'auth.features_title': 'Tudo que você precisa',
    'auth.features_subtitle': 'Recursos poderosos para simplificar sua vida financeira',
    'auth.feature_pix_desc': 'Transferências em segundos, 24 horas por dia, 7 dias por semana. Sem limites, sem complicação.',
    'auth.total_security': 'Segurança Total',
    'auth.feature_security_desc': 'Proteção avançada com criptografia de ponta e autenticação em múltiplos fatores.',
    'auth.virtual_card': 'Cartão Virtual',
    'auth.feature_card_desc': 'Cartão virtual gratuito para compras online com controle total pelo app.',
    'auth.fully_digital': '100% Digital',
    'auth.feature_digital_desc': 'Abra sua conta em minutos, sem burocracia. Tudo pelo celular.',
    'auth.investments': 'Investimentos',
    'auth.feature_investments_desc': 'Faça seu dinheiro render com opções de investimento simplificadas.',
    'auth.zero_fees': 'Zero Tarifas',
    'auth.feature_fees_desc': 'Conta digital de demonstração para navegar, testar e observar o produto.',
    'auth.testimonial_quote': '"Com o DogBank, a demo mostra a jornada do cliente e a investigação operacional no mesmo cenário."',
    'auth.testimonial_author': 'Equipe DogBank',
    'auth.testimonial_role': 'Demo de observabilidade',
    'auth.cta_title': 'Pronto para começar?',
    'auth.cta_subtitle': 'Entre com um usuário de demonstração e percorra PIX, carteira e investimentos.',
    'auth.access_demo': 'Acessar demo',
    'auth.footer_copyright': '© 2026 DogBank. Ambiente de demonstração.',
    'auth.footer_terms': 'Termos',
    'auth.footer_privacy': 'Privacidade',
    'auth.footer_contact': 'Contato',
  },
  es: {
    // LoginForm
    'auth.login_form_title': 'Bienvenido a DogBank',
    'auth.cpf_subtitle': 'Ingresa tu CPF para continuar',
    'auth.cpf_invalid': 'CPF inválido. Ingresa los 11 dígitos de tu CPF.',
    'auth.cpf_label': 'CPF',
    'auth.cpf_placeholder': '000.000.000-00',
    'auth.continue': 'Continuar',
    'auth.not_client_yet': '¿Aún no eres cliente?',
    'auth.open_account': 'Abre tu cuenta',
    // PasswordForm
    'auth.password_title': 'Ingresa tu contraseña',
    'auth.password_subtitle': 'Para acceder a tu cuenta DogBank',
    'auth.password_label': 'Contraseña',
    'auth.wrong_password_retry': 'Contraseña incorrecta. Inténtalo de nuevo.',
    'auth.back': 'Volver',
    'auth.login': 'Iniciar sesión',
    'auth.signing_in': 'Iniciando sesión...',
    'auth.forgot_password': 'Olvidé mi contraseña',
    // LoginPage
    'auth.welcome_back': 'Bienvenido de nuevo',
    'auth.login_hero_subtitle': 'Accede a tu cuenta y gestiona tus finanzas de forma simple y segura.',
    'auth.advanced_security': 'Seguridad Avanzada',
    'auth.two_step_auth': 'Autenticación en 2 pasos',
    'auth.instant_pix': 'PIX Instantáneo',
    'auth.transfers_in_seconds': 'Transferencias en segundos',
    'auth.back_to_home': 'Volver al inicio',
    'auth.login_account_title': 'Accede a tu cuenta',
    'auth.verifying': 'Verificando...',
    'auth.no_account': '¿No tienes una cuenta?',
    'auth.create_account': 'Crear cuenta',
    'auth.demo_disclaimer': 'Este es un proyecto de demostración. No es un banco real.',
    // PasswordPage
    'auth.cpf_not_registered': 'CPF no registrado. Verifica el número ingresado o crea una cuenta.',
    'auth.wrong_password_check': 'Contraseña incorrecta. Verifica e inténtalo de nuevo.',
    'auth.connection_error': 'Error de conexión. Verifica tu conexión a internet e inténtalo de nuevo.',
    'auth.generic_error': 'Ocurrió un error. Inténtalo de nuevo.',
    'auth.pin_length': 'Ingresa los {n} dígitos de la contraseña.',
    'auth.user_not_found': 'Usuario no encontrado',
    'auth.login_error': 'Error de inicio de sesión',
    'auth.back_verify_cpf': '← Volver y verificar el CPF',
    'auth.secure_access': 'Acceso Seguro',
    'auth.password_hero_subtitle': 'Ingresa tu contraseña de 6 dígitos para acceder a tu cuenta con total seguridad.',
    'auth.advanced_encryption': 'Cifrado Avanzado',
    'auth.advanced_encryption_desc': 'Tus datos protegidos con tecnología de última generación',
    'auth.cpf_display': 'CPF: {n}',
    'auth.validating': 'Validando...',
    'auth.forgot_password_question': '¿Olvidaste la contraseña?',
    'auth.recover_access': 'Recuperar acceso',
    // LandingPage
    'auth.nav_features': 'Recursos',
    'auth.nav_security': 'Seguridad',
    'auth.nav_about': 'Acerca de',
    'auth.access_account': 'Acceder a la cuenta',
    'auth.hero_badge': 'PIX, CDI 100% y Bitcoin en una demo observable',
    'auth.hero_subtitle': 'Una experiencia bancaria para demostrar recorridos reales de PIX, cartera de inversiones y observabilidad de extremo a extremo.',
    'auth.start_now': 'Comenzar ahora',
    'auth.learn_more': 'Saber más',
    'auth.stat_transactional': 'Flujo transaccional',
    'auth.stat_fixed_income': 'Renta fija',
    'auth.stat_market_price': 'Cotización de mercado',
    'auth.features_title': 'Todo lo que necesitas',
    'auth.features_subtitle': 'Recursos potentes para simplificar tu vida financiera',
    'auth.feature_pix_desc': 'Transferencias en segundos, 24 horas al día, 7 días a la semana. Sin límites, sin complicaciones.',
    'auth.total_security': 'Seguridad Total',
    'auth.feature_security_desc': 'Protección avanzada con cifrado de última generación y autenticación de múltiples factores.',
    'auth.virtual_card': 'Tarjeta Virtual',
    'auth.feature_card_desc': 'Tarjeta virtual gratuita para compras online con control total desde la app.',
    'auth.fully_digital': '100% Digital',
    'auth.feature_digital_desc': 'Abre tu cuenta en minutos, sin burocracia. Todo desde el móvil.',
    'auth.investments': 'Inversiones',
    'auth.feature_investments_desc': 'Haz que tu dinero rinda con opciones de inversión simplificadas.',
    'auth.zero_fees': 'Cero Comisiones',
    'auth.feature_fees_desc': 'Cuenta digital de demostración para navegar, probar y observar el producto.',
    'auth.testimonial_quote': '"Con DogBank, la demo muestra el recorrido del cliente y la investigación operativa en el mismo escenario."',
    'auth.testimonial_author': 'Equipo DogBank',
    'auth.testimonial_role': 'Demo de observabilidad',
    'auth.cta_title': '¿Listo para comenzar?',
    'auth.cta_subtitle': 'Entra con un usuario de demostración y recorre PIX, cartera e inversiones.',
    'auth.access_demo': 'Acceder a la demo',
    'auth.footer_copyright': '© 2026 DogBank. Entorno de demostración.',
    'auth.footer_terms': 'Términos',
    'auth.footer_privacy': 'Privacidad',
    'auth.footer_contact': 'Contacto',
  },
  en: {
    // LoginForm
    'auth.login_form_title': 'Welcome to DogBank',
    'auth.cpf_subtitle': 'Enter your CPF to continue',
    'auth.cpf_invalid': 'Invalid CPF. Enter the 11 digits of your CPF.',
    'auth.cpf_label': 'CPF',
    'auth.cpf_placeholder': '000.000.000-00',
    'auth.continue': 'Continue',
    'auth.not_client_yet': 'Not a customer yet?',
    'auth.open_account': 'Open your account',
    // PasswordForm
    'auth.password_title': 'Enter your password',
    'auth.password_subtitle': 'To access your DogBank account',
    'auth.password_label': 'Password',
    'auth.wrong_password_retry': 'Incorrect password. Please try again.',
    'auth.back': 'Back',
    'auth.login': 'Log in',
    'auth.signing_in': 'Logging in...',
    'auth.forgot_password': 'I forgot my password',
    // LoginPage
    'auth.welcome_back': 'Welcome back',
    'auth.login_hero_subtitle': 'Access your account and manage your finances simply and securely.',
    'auth.advanced_security': 'Advanced Security',
    'auth.two_step_auth': 'Two-step authentication',
    'auth.instant_pix': 'Instant PIX',
    'auth.transfers_in_seconds': 'Transfers in seconds',
    'auth.back_to_home': 'Back to home',
    'auth.login_account_title': 'Log in to your account',
    'auth.verifying': 'Verifying...',
    'auth.no_account': "Don't have an account?",
    'auth.create_account': 'Create account',
    'auth.demo_disclaimer': 'This is a demonstration project. It is not a real bank.',
    // PasswordPage
    'auth.cpf_not_registered': 'CPF not registered. Check the number entered or create an account.',
    'auth.wrong_password_check': 'Incorrect password. Check and try again.',
    'auth.connection_error': 'Connection error. Check your internet and try again.',
    'auth.generic_error': 'An error occurred. Please try again.',
    'auth.pin_length': 'Enter the {n} digits of your password.',
    'auth.user_not_found': 'User not found',
    'auth.login_error': 'Login error',
    'auth.back_verify_cpf': '← Go back and check the CPF',
    'auth.secure_access': 'Secure Access',
    'auth.password_hero_subtitle': 'Enter your 6-digit password to access your account with complete security.',
    'auth.advanced_encryption': 'Advanced Encryption',
    'auth.advanced_encryption_desc': 'Your data protected with cutting-edge technology',
    'auth.cpf_display': 'CPF: {n}',
    'auth.validating': 'Validating...',
    'auth.forgot_password_question': 'Forgot your password?',
    'auth.recover_access': 'Recover access',
    // LandingPage
    'auth.nav_features': 'Features',
    'auth.nav_security': 'Security',
    'auth.nav_about': 'About',
    'auth.access_account': 'Access account',
    'auth.hero_badge': 'PIX, 100% CDI and Bitcoin in an observable demo',
    'auth.hero_subtitle': 'A banking experience to demonstrate real PIX journeys, investment portfolio and end-to-end observability.',
    'auth.start_now': 'Get started now',
    'auth.learn_more': 'Learn more',
    'auth.stat_transactional': 'Transactional flow',
    'auth.stat_fixed_income': 'Fixed income',
    'auth.stat_market_price': 'Market price',
    'auth.features_title': 'Everything you need',
    'auth.features_subtitle': 'Powerful features to simplify your financial life',
    'auth.feature_pix_desc': 'Transfers in seconds, 24 hours a day, 7 days a week. No limits, no hassle.',
    'auth.total_security': 'Total Security',
    'auth.feature_security_desc': 'Advanced protection with cutting-edge encryption and multi-factor authentication.',
    'auth.virtual_card': 'Virtual Card',
    'auth.feature_card_desc': 'Free virtual card for online purchases with full control from the app.',
    'auth.fully_digital': '100% Digital',
    'auth.feature_digital_desc': 'Open your account in minutes, with no bureaucracy. All from your phone.',
    'auth.investments': 'Investments',
    'auth.feature_investments_desc': 'Make your money grow with simplified investment options.',
    'auth.zero_fees': 'Zero Fees',
    'auth.feature_fees_desc': 'Demonstration digital account to browse, test and observe the product.',
    'auth.testimonial_quote': '"With DogBank, the demo shows the customer journey and operational investigation in the same scenario."',
    'auth.testimonial_author': 'DogBank Team',
    'auth.testimonial_role': 'Observability demo',
    'auth.cta_title': 'Ready to get started?',
    'auth.cta_subtitle': 'Log in with a demo user and explore PIX, wallet and investments.',
    'auth.access_demo': 'Access demo',
    'auth.footer_copyright': '© 2026 DogBank. Demonstration environment.',
    'auth.footer_terms': 'Terms',
    'auth.footer_privacy': 'Privacy',
    'auth.footer_contact': 'Contact',
  },
  it: {
    // LoginForm
    'auth.login_form_title': 'Benvenuto in DogBank',
    'auth.cpf_subtitle': 'Inserisci il tuo CPF per continuare',
    'auth.cpf_invalid': 'CPF non valido. Inserisci le 11 cifre del tuo CPF.',
    'auth.cpf_label': 'CPF',
    'auth.cpf_placeholder': '000.000.000-00',
    'auth.continue': 'Continua',
    'auth.not_client_yet': 'Non sei ancora cliente?',
    'auth.open_account': 'Apri il tuo conto',
    // PasswordForm
    'auth.password_title': 'Inserisci la tua password',
    'auth.password_subtitle': 'Per accedere al tuo conto DogBank',
    'auth.password_label': 'Password',
    'auth.wrong_password_retry': 'Password errata. Riprova.',
    'auth.back': 'Indietro',
    'auth.login': 'Accedi',
    'auth.signing_in': 'Accesso in corso...',
    'auth.forgot_password': 'Ho dimenticato la password',
    // LoginPage
    'auth.welcome_back': 'Bentornato',
    'auth.login_hero_subtitle': 'Accedi al tuo conto e gestisci le tue finanze in modo semplice e sicuro.',
    'auth.advanced_security': 'Sicurezza Avanzata',
    'auth.two_step_auth': 'Autenticazione in 2 passaggi',
    'auth.instant_pix': 'PIX Istantaneo',
    'auth.transfers_in_seconds': 'Trasferimenti in pochi secondi',
    'auth.back_to_home': "Torna all'inizio",
    'auth.login_account_title': 'Accedi al tuo conto',
    'auth.verifying': 'Verifica in corso...',
    'auth.no_account': 'Non hai un conto?',
    'auth.create_account': 'Crea un conto',
    'auth.demo_disclaimer': 'Questo è un progetto dimostrativo. Non è una banca reale.',
    // PasswordPage
    'auth.cpf_not_registered': 'CPF non registrato. Verifica il numero inserito o crea un conto.',
    'auth.wrong_password_check': 'Password errata. Verifica e riprova.',
    'auth.connection_error': 'Errore di connessione. Verifica la tua connessione internet e riprova.',
    'auth.generic_error': 'Si è verificato un errore. Riprova.',
    'auth.pin_length': 'Inserisci le {n} cifre della password.',
    'auth.user_not_found': 'Utente non trovato',
    'auth.login_error': 'Errore di accesso',
    'auth.back_verify_cpf': '← Torna indietro e verifica il CPF',
    'auth.secure_access': 'Accesso Sicuro',
    'auth.password_hero_subtitle': 'Inserisci la tua password di 6 cifre per accedere al tuo conto in totale sicurezza.',
    'auth.advanced_encryption': 'Crittografia Avanzata',
    'auth.advanced_encryption_desc': 'I tuoi dati protetti con tecnologia all\'avanguardia',
    'auth.cpf_display': 'CPF: {n}',
    'auth.validating': 'Convalida in corso...',
    'auth.forgot_password_question': 'Hai dimenticato la password?',
    'auth.recover_access': "Recupera l'accesso",
    // LandingPage
    'auth.nav_features': 'Funzionalità',
    'auth.nav_security': 'Sicurezza',
    'auth.nav_about': 'Chi siamo',
    'auth.access_account': 'Accedi al conto',
    'auth.hero_badge': 'PIX, CDI 100% e Bitcoin in una demo osservabile',
    'auth.hero_subtitle': "Un'esperienza bancaria per dimostrare percorsi reali di PIX, portafoglio di investimenti e osservabilità end-to-end.",
    'auth.start_now': 'Inizia ora',
    'auth.learn_more': 'Scopri di più',
    'auth.stat_transactional': 'Flusso transazionale',
    'auth.stat_fixed_income': 'Reddito fisso',
    'auth.stat_market_price': 'Quotazione di mercato',
    'auth.features_title': 'Tutto ciò di cui hai bisogno',
    'auth.features_subtitle': 'Funzionalità potenti per semplificare la tua vita finanziaria',
    'auth.feature_pix_desc': 'Trasferimenti in pochi secondi, 24 ore su 24, 7 giorni su 7. Senza limiti, senza complicazioni.',
    'auth.total_security': 'Sicurezza Totale',
    'auth.feature_security_desc': 'Protezione avanzata con crittografia all\'avanguardia e autenticazione a più fattori.',
    'auth.virtual_card': 'Carta Virtuale',
    'auth.feature_card_desc': 'Carta virtuale gratuita per acquisti online con pieno controllo dall\'app.',
    'auth.fully_digital': '100% Digitale',
    'auth.feature_digital_desc': 'Apri il tuo conto in pochi minuti, senza burocrazia. Tutto dal cellulare.',
    'auth.investments': 'Investimenti',
    'auth.feature_investments_desc': 'Fai fruttare il tuo denaro con opzioni di investimento semplificate.',
    'auth.zero_fees': 'Zero Commissioni',
    'auth.feature_fees_desc': 'Conto digitale dimostrativo per navigare, testare e osservare il prodotto.',
    'auth.testimonial_quote': '"Con DogBank, la demo mostra il percorso del cliente e l\'indagine operativa nello stesso scenario."',
    'auth.testimonial_author': 'Team DogBank',
    'auth.testimonial_role': 'Demo di osservabilità',
    'auth.cta_title': 'Pronto per iniziare?',
    'auth.cta_subtitle': 'Accedi con un utente dimostrativo ed esplora PIX, portafoglio e investimenti.',
    'auth.access_demo': 'Accedi alla demo',
    'auth.footer_copyright': '© 2026 DogBank. Ambiente dimostrativo.',
    'auth.footer_terms': 'Termini',
    'auth.footer_privacy': 'Privacy',
    'auth.footer_contact': 'Contatti',
  },
};

export default auth;
